import {Link, type LinkProps, useRefObjectAsForwardedRef} from '@primer/react'
import {useRef} from 'react'

import styles from './link-cell.module.css'

export const LinkCell = ({
  ref: forwardedRef = null,
  ...props
}: Omit<LinkProps, 'sx'> & {dangerousHtml?: string; isDisabled?: boolean} & {
  ref?: React.Ref<HTMLAnchorElement | null>
}) => {
  const ref = useRef<HTMLAnchorElement>(null)
  useRefObjectAsForwardedRef(forwardedRef, ref)
  const {isDisabled, ...restProps} = props
  return <Link target="_blank" rel="noreferrer" tabIndex={-1} {...restProps} ref={ref} className={styles.Link} />
}

LinkCell.displayName = 'LinkCell'
